import { Dayjs } from 'dayjs';

import { LatLng } from 'leaflet';

import {
  CHANGE_LICENCE_AREA_SELECTED,
  CHANGE_VELOCITY_LAYER_TIMING,
  CHANGE_START_DATE,
  CHANGE_CURRENT_TIME,
  CHANGE_STARTING_TIME,
  CHANGE_TIMELINE_PLAYING,
  CHANGE_WEATHER_HORODATETIME,
  CHANGE_WIND_PARTICULES_SELECTED,
  CHANGE_EVENT_WIND_PARTICULES_SELECTED,
  CHANGE_GRID_LAYER_SELECTED,
  CHANGE_EVENT_GRID_LAYER_SELECTED,
  CHANGE_MARKER_COORDINATES,
  CHANGE_EVENT_LIBRARY_PANEL,
  CHANGE_EVENT_LIBRARY_FILTERS,
  CHANGE_CURRENT_TIME_COMPARISON,
  CHANGE_TOTAL_KPI_LINE_CHART,
  CHANGE_MODAL_IS_OPEN,
  CHANGE_EVENT_NAME,
  CHANGE_LAYER_SELECTED,
  CHANGE_EVENT_LICENCE_AREA_SELECTED,
  CHANGE_EVENT_LAYER_SELECTED,
  CHANGE_TIMELINE_MODE,
  CHANGE_SUBSTATIONS_SELECTED,
  CHANGE_DISTRICT_SUBSTATIONS_SELECTED,
  CHANGE_EVENT_SUBSTATIONS_SELECTED,
} from './constants';

import { LayerType } from '@/components/P4RMap2/types';

export type TimelineType = [Dayjs | null, number, number?];
//remove optional sign when updated to currentTime only
export interface ChangeCurrentTimePayload {
  currentTime?: TimelineType;
  nextTime: TimelineType;
}

export interface ChangeEventLibraryFilters {
  status?: string[];
  weatherEventName?: string;
  districtIds?: string[];
  warningLevels?: string[];
  startDate?: Dayjs;
  endDate?: Dayjs;
  advancedFiltersDisplay?: boolean;
  networkImpact?: string[];
  weatherData?: string[];
}

export type P4RContextType = typeof initialState;

export const initialState = {
  velocityLayerTiming: 0,
  changeVelocityLayerTiming: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _timing: number,
  ): void => {},
  licenceAreaSelected: null as null | string | boolean,
  changeLicenceAreaSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _currentTime: string | boolean,
  ): void => {},
  layerSelected: null as null | LayerType,
  changeLayerSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _layerSelected: LayerType,
  ): void => {},
  windParticulesSelected: true,
  changeWindParticulesSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _layerSelected: boolean,
  ): void => {},
  eventWindParticulesSelected: true,
  changeEventWindParticulesSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _layerSelected: boolean,
  ): void => {},
  gridLayerSelected: false as boolean,
  changeGridLayerSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _layerSelected: boolean,
  ): void => {},
  eventGridLayerSelected: false as boolean,
  changeEventGridLayerSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _layerSelected: boolean,
  ): void => {},
  eventLicenceAreaSelected: null as null | string | boolean,
  changeEventLicenceAreaSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _currentTime: string | boolean,
  ): void => {},
  eventLayerSelected: null as null | LayerType,
  changeEventLayerSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _layerSelected: LayerType,
  ): void => {},
  startDate: null as [Dayjs, string, string, string] | null,
  changeStartDate: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _startDate: [Dayjs, string, string, string],
  ): void => {},
  currentTime: [null, 0, 0] as TimelineType,
  nextTime: [null, 1] as TimelineType,
  startingTime: {
    currentTime: [null, 0, 0] as TimelineType,
    nextTime: [null, 1] as TimelineType,
  },
  currentTimeComparison: [null, 0, 0] as TimelineType,
  nextTimeComparison: [null, 1] as TimelineType,
  changeCurrentTime: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _currentTime: ChangeCurrentTimePayload,
  ): void => {},
  changeStartingTime: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _startingTime: {
      currentTime: TimelineType;
      nextTime: TimelineType;
    },
  ): void => {},
  changeCurrentTimeComparison: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _currentTime: ChangeCurrentTimePayload,
  ): void => {},
  timelinePlaying: null as null | boolean,
  changeTimelinePlaying: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _playing: boolean,
  ): void => {},
  weatherHorodatetime: null as string | null,
  changeWeatherHorodatetime: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _weatherHorodatetime: string,
  ): void => {},
  markerCoordinates: null as LatLng | null,
  changeMarkerCoordinates: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _markerCoordinates: LatLng | null,
  ): void => {},
  eventLibraryPanel: true,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeEventLibraryPanel: (_display: boolean): void => {},
  eventLibraryFilters: {
    status: [],
    weatherEventName: undefined,
    networkImpact: [],
    weatherData: [],
  } as ChangeEventLibraryFilters,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeEventLibraryFilters: (_filters: ChangeEventLibraryFilters): void => {},
  totalKpiforLineChart: [] as any[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeTotalKpiForLineChart: (_payload: any): void => {},
  isModalOpen: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeModalIsOpen: (_payload: boolean): void => {},
  eventName: '',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeEventName: (_payload: string): void => {},
  timelineMode: 'live' as 'live' | 'replay' | 'historical',
  substationsSelected: new Set([] as SubstationType[]),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeSubstationsSelected: (_payload: Set<SubstationType>): void => {},
  districtSubstationsSelected: new Set([
    'HV',
    '33kV',
    '132kV',
  ] as SubstationType[]),
  changeDistrictSubstationsSelected: (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _payload: Set<SubstationType>,
  ): void => {},
  eventSubstationsSelected: new Set([] as SubstationType[]),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeEventSubstationsSelected: (_payload: Set<SubstationType>): void => {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  changeTimelineMode: (_mode: 'live' | 'replay' | 'historical'): void => {},
};

const P4RReducer = (
  state: {
    velocityLayerTiming: number;
    licenceAreaSelected: null | string | boolean;
    layerSelected: null | LayerType;
    windParticulesSelected: boolean;
    eventWindParticulesSelected: boolean;
    gridLayerSelected: boolean;
    eventGridLayerSelected: boolean;
    eventLicenceAreaSelected: null | string | boolean;
    eventLayerSelected: null | LayerType;
    startDate: [Dayjs, string, string, string] | null;
    currentTime: TimelineType;
    nextTime: TimelineType;
    startingTime: { currentTime: TimelineType; nextTime: TimelineType };
    currentTimeComparison: TimelineType;
    nextTimeComparison: TimelineType;
    timelinePlaying: boolean | null;
    weatherHorodatetime: string | null;
    markerCoordinates: LatLng | null;
    eventLibraryPanel: boolean;
    eventLibraryFilters: ChangeEventLibraryFilters;
    totalKpiforLineChart: any[];
    isModalOpen: boolean;
    eventName: string;
    substationsSelected: Set<SubstationType>;
    districtSubstationsSelected: Set<SubstationType>;
    eventSubstationsSelected: Set<SubstationType>;
    timelineMode: 'live' | 'replay' | 'historical';
  },
  action: {
    type: string;
    payload: any;
  },
) => {
  const { type, payload } = action;

  switch (type) {
    case CHANGE_VELOCITY_LAYER_TIMING:
      return {
        ...state,
        velocityLayerTiming: payload,
      };
    case CHANGE_LICENCE_AREA_SELECTED:
      return {
        ...state,
        licenceAreaSelected: payload,
      };
    case CHANGE_LAYER_SELECTED:
      return {
        ...state,
        layerSelected: payload,
      };
    case CHANGE_WIND_PARTICULES_SELECTED:
      return {
        ...state,
        windParticulesSelected: payload,
      };
    case CHANGE_EVENT_WIND_PARTICULES_SELECTED:
      return {
        ...state,
        eventWindParticulesSelected: payload,
      };
    case CHANGE_GRID_LAYER_SELECTED:
      return {
        ...state,
        gridLayerSelected: payload,
      };
    case CHANGE_EVENT_GRID_LAYER_SELECTED:
      return {
        ...state,
        eventGridLayerSelected: payload,
      };
    case CHANGE_EVENT_LICENCE_AREA_SELECTED:
      return {
        ...state,
        eventLicenceAreaSelected: payload,
      };
    case CHANGE_EVENT_LAYER_SELECTED:
      return {
        ...state,
        eventLayerSelected: payload,
      };
    case CHANGE_START_DATE:
      return {
        ...state,
        startDate: payload,
      };
    case CHANGE_CURRENT_TIME:
      return {
        ...state,
        currentTime: payload.currentTime,
        nextTime: payload.nextTime,
      };
    case CHANGE_STARTING_TIME:
      return {
        ...state,
        startingTime: payload,
      };
    case CHANGE_CURRENT_TIME_COMPARISON:
      return {
        ...state,
        currentTimeComparison: payload.currentTime,
        nextTimeComparison: payload.nextTime,
      };
    case CHANGE_TIMELINE_PLAYING:
      return {
        ...state,
        timelinePlaying: payload,
      };

    case CHANGE_WEATHER_HORODATETIME:
      return {
        ...state,
        weatherHorodatetime: payload,
      };
    case CHANGE_MARKER_COORDINATES:
      return {
        ...state,
        markerCoordinates: payload,
      };
    case CHANGE_EVENT_LIBRARY_PANEL:
      return {
        ...state,
        eventLibraryPanel: payload,
      };
    case CHANGE_EVENT_LIBRARY_FILTERS:
      return {
        ...state,
        eventLibraryFilters: payload,
      };
    case CHANGE_TOTAL_KPI_LINE_CHART:
      return {
        ...state,
        totalKpiforLineChart: payload,
      };
    case CHANGE_MODAL_IS_OPEN:
      return {
        ...state,
        isModalOpen: payload,
      };
    case CHANGE_EVENT_NAME:
      return {
        ...state,
        eventName: payload,
      };
    case CHANGE_TIMELINE_MODE:
      return {
        ...state,
        timelineMode: payload,
      };
    case CHANGE_SUBSTATIONS_SELECTED:
      return {
        ...state,
        substationsSelected: payload,
      };
    case CHANGE_DISTRICT_SUBSTATIONS_SELECTED:
      return {
        ...state,
        districtSubstationsSelected: payload,
      };
    case CHANGE_EVENT_SUBSTATIONS_SELECTED:
      return {
        ...state,
        eventSubstationsSelected: payload,
      };
    default:
      return state;
  }
};

export default P4RReducer;
